export enum QuestObjectiveActions {
	REACH_LEVEL = "REACH_LEVEL",
	HAVE_SETTLEMENTS_ON_LEVEL = "HAVE_SETTLEMENTS_ON_LEVEL",
	HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL = "HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL",
	DISCOVER_SPECIFIC_TILE = "DISCOVER_SPECIFIC_TILE",
	CONNECT_SPECIFIC_SETTLEMENT = "CONNECT_SPECIFIC_SETTLEMENT",
	BUILD_BUILDING = "BUILD_BUILDING",
	USE_RESOURCES = "USE_RESOURCES",
	CHANGE_TERRAIN = "CHANGE_TERRAIN",
	CLEAR_TILES = "CLEAR_TILES",
	HAVE_TERRAIN = "HAVE_TERRAIN",
	HAVE_RESOURCE = "HAVE_RESOURCE",
	SALVAGE = "SALVAGE",
	TRADE = "TRADE",
	DEFEAT = "DEFEAT",
	USE_SUPER_CLICKER = "USE_SUPER_CLICKER",
	USE_CLICK_MULTIPLIER = "USE_CLICK_MULTIPLIER",
	HAVE_SETTLEMENTS_AXIS = "HAVE_SETTLEMENTS_AXIS",
	HAVE_FULL_SETTLEMENTS = "HAVE_FULL_SETTLEMENTS",
	COLLECT_COINS = "COLLECT_COINS",
	COMPLETE_DAILY_QUESTS = "COMPLETE_DAILY_QUESTS",
	CLICK_ON_SETTLEMENT = "CLICK_ON_SETTLEMENT",
	WATCH_ADS = "WATCH_ADS",
	SPEND_RESOURCES = "SPEND_RESOURCES",
	INCREASE_RESOURCE_INCOME = "INCREASE_RESOURCE_INCOME",
	FINISH_QUEST = "FINISH_QUEST",
	HAVE_STORAGE = "HAVE_STORAGE",
	PIGGY_BANK_PROGRESS = "PIGGY_BANK_PROGRESS",
	CLEAR_PLAGUE = "CLEAR_PLAGUE",
}
